import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FileMissingIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.7 5.74H11.34V4.34H12.7V5.74ZM10 5.74H8.64V4.34H10V5.74ZM7.3 5.74H5.94V4.34H7.3V5.74ZM5.94 7.14H7.3V8.54H5.94V7.14ZM12.7 11.34H11.34V9.94H12.7V8.54H14.04V7.16H12.7V8.54H11.34V7.14H12.7V5.74H14.06V7.14H15.4V8.54H16.74V9.94H18.1V11.34H16.74V9.96H15.4V11.34H14.04V9.96H12.7V11.34ZM7.3 11.34H5.94V9.94H7.3V11.34ZM18.1 14.14H16.74V12.74H18.1V14.14ZM7.3 14.14H5.94V12.74H7.3V14.14ZM18.1 16.94H16.74V15.54H18.1V16.94ZM7.3 16.94H5.94V15.54H7.3V16.94ZM18.1 19.74H16.74V18.34H18.1V19.74ZM12.7 19.74H11.34V18.34H12.7V19.74ZM10 19.74H8.64V18.34H10V19.74ZM7.3 19.74H5.94V18.34H7.3V19.74ZM14.04 18.34H15.4V19.74H14.04V18.34ZM15.38 8.54H14.06V9.94H15.38V8.54Z" />
    </SvgIcon>
  );
});
